import { Button } from '@mui/material';
import { MdSearch } from '@teamworksdev/icons';
import type { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import { DataTableContextProps } from '../data-table-context';
import { DataTablePlaceholder } from './data-table-placeholder';

type EmptySearchResultsPlaceholderProps = ComponentProps<
  NonNullable<DataTableContextProps<any>['EmptySearchResultsPlaceholder']>
>;

export const DefaultEmptySearchResultsPlaceholder = ({
  clearSearch,
}: EmptySearchResultsPlaceholderProps) => {
  const { t } = useTranslation();
  return (
    <DataTablePlaceholder
      icon={<MdSearch size={24} />}
      title={t('noItemsFound')}
      description={t('noItemsFound')}
    >
      <Button onClick={clearSearch}>{t('resetSearch')}</Button>
    </DataTablePlaceholder>
  );
};
